var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { notificationBar } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
var borderColors = {
    success: notificationBar.success.badgeBackground,
    warning: notificationBar.warning.badgeBackground,
    info: notificationBar.info.badgeBackground,
    error: notificationBar.error.badgeBackground
};
var backgroundColors = {
    success: notificationBar.success.background,
    warning: notificationBar.warning.background,
    info: notificationBar.info.background,
    error: notificationBar.error.background
};
export var MessageBoxSyf = styled(MessageBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-width: 2px;\n  border-color: ", ";\n  background-color: ", ";\n"], ["\n  border-width: 2px;\n  border-color: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var type = _a.type;
    return borderColors[type];
}, function (_a) {
    var type = _a.type;
    return backgroundColors[type];
});
var templateObject_1;
